import { useEffect } from 'react';
import { PWAStatusBar } from './PWAStatusBar';
import { ServiceWorkerManager } from './ServiceWorkerManager';
import { AssetLoadingErrorHandler } from './AssetLoadingErrorHandler';
import { useNativeFeatures } from '@/hooks/useNativeFeatures';
import { useOfflineStorage } from '@/hooks/useOfflineStorage';

export const PWAFeatures = () => {
  const { isNative, initializeNativeFeatures } = useNativeFeatures();
  const { isOnline } = useOfflineStorage();

  useEffect(() => {
    // Initialize native features if running in native app
    if (isNative) {
      initializeNativeFeatures();
    }

    // Set up app badge (if supported)
    if ('setAppBadge' in navigator) {
      if (!isOnline) {
        (navigator as any).setAppBadge(1);
      } else {
        (navigator as any).clearAppBadge();
      }
    }
  }, [isNative, isOnline, initializeNativeFeatures]);

  return (
    <>
      <PWAStatusBar />
      <ServiceWorkerManager />
      <AssetLoadingErrorHandler />
    </>
  );
};